<template>
  <div class="instruct-wrapper" v-if="student_data.length > 0 || isLoading">
    <div class="tab-options"></div>
    <div class="instruct-widget">
      <multipane class="custom-resizer" layout="vertical">
        <div class="instruct-list">
          <div class="instruct-header">
            <div class="search-add-btn-widget">
              <div class="search-widget">
                <img src="@/assets/icons/search.svg" alt />
                <input v-model="search_student_input" type="text" placeholder="Type in to Search…" />
              </div>
            </div>
            <div class="school-widget">
              <classDropdown @onSubmit="getSelectedSchool">
                <h2 v-if="!selected_school">Company name</h2>
                <h2 v-else>{{ selected_school.data.name }}</h2>
              </classDropdown>
              <div class="table-options"></div>
            </div>
            <div class="filter-widget">
              <div class="filter-select-widget">
                <span class="filter-title">Filter by:</span>
                <filter-select @onSubmit="filterSchoolStudent" v-model="selected_filter" :content="view_filter">
                  <div class="filter-selected-label">
                    <span v-if="selected_filter == 'all'">All Years</span>
                  </div>
                </filter-select>
              </div>
              <div class="filter-widget-options">
                <c-button v-if="show_selected_student_options" @click="approveSelectedStudent()" class="btn-approve">
                  Contact</c-button>
              </div>
            </div>
          </div>
          <div class="instruct-body">
            <!-- Data preview -->
            <table class="table-data">
              <thead class="table-header">
                <tr class="stack-title">
                  <th class="stick-title" width="200">
                    <div class="force-start">
                      <input @change="checkAllStudent" type="checkbox" /> Name
                    </div>
                  </th>
                  <th class="stick-title">Email</th>
                  <th class="stick-title">Assignment</th>
                  <th class="stick-title">year</th>
                  <th class="stick-title" width="140">Contact</th>
                </tr>
              </thead>
              <tbody class="table-body">
                <template>
                  <tr v-for="(item, index) in student_data" :key="index" class="row-data">
                    <td>
                      <div class="profile-content">
                        <input @change="checkStudent" v-model="item.checked" class="checkbox" type="checkbox" />
                        <img class="student-profile" v-if="item.profile_picture" :src="$fullUrl('images/profiles/' + item.profile_picture)
                          " :class="{ override: index > 0 }" />

                        <div v-else class="profile-alphabet">
                          <span>{{
                            $nameInitials(
                              item.first_name + " " + item.last_name
                            ) | validate
                          }}</span>
                        </div>
                        {{ item.first_name + " " + item.last_name }}
                      </div>
                    </td>
                    <td class="email">{{ item.email }}</td>
                    <td></td>
                    <td></td>
                    <td>
                      <button class="btn-approve">Contact</button>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>

            <!-- Loading preview -->
            <div class="loading-widget" v-if="isLoading">
              <loading :height="40" :width="40" :active="true" color="#000" :is-full-page="false" />
            </div>
          </div>
        </div>
        <multipane-resizer></multipane-resizer>
        <div :style="{ flexGrow: 1 }" class="instruct-details student-details">
          <div class="instruct-header">
            <img class="student-profile" src="@/assets/images/avatar.svg" />
            <h2 class="student-name">Diane Fisher</h2>
            <h4 class="student-job">Web Developer</h4>
            <p class="student-content">
              A kiddo who uses Bootstrap and Laravel in web development.
              Currently playing around with design via Figma A kiddo who uses
              Bootstrap and Laravel in web development. Currently playing around
              with design via Figma
            </p>
            <p class="student-email">joeylenerivera@gmail.com</p>
            <p class="student-phone">+46 765 543 23</p>
          </div>
          <div class="instruct-body">
            <div class="student-post-widget">
              <div class="header-widget">
                <h4 class="title">All posts</h4>
                <button class="btn-view-in-feed">View from the feed</button>
              </div>
              <div class="body-widget">
                <div class="post-widget-item" v-for="(item, index) in 4" :key="index">
                  <div class="post-header">
                    <img class="post-profile" src="@/assets/images/avatar.svg" alt="" />
                    <div class="post-ower">
                      <h4 class="name">Dianne Fisher</h4>
                      <span class="time">2 weeks ago</span>
                    </div>
                  </div>
                  <div class="post-body">
                    <p class="post-content">
                      This is a feed. It can be long, or short. Depends on what
                      you have to say. It can have some hashtags too. #likethis
                    </p>
                    <img class="post-image" src="https://picsum.photos/200/300" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </multipane>
    </div>

    <!-- Reminder modal -->
    <remainderModal v-if="show_remainder" :user="user_to_remaind" :type="remind_type" @close="closeRemainder">
    </remainderModal>
  </div>
  <div class="instruct-wrapper" v-else>
    <div class="student-not-found-widget">
      <widgetNotFoundWidget title="No Consultants Found"
        content="Looks like you haven’t any consultants yet, Consultants need to complete organization  process to be available in this page">
        <img class="widget-img" src="@/assets/admin-icon/add-student-icon.svg" />
      </widgetNotFoundWidget>
    </div>
  </div>
</template>

<script>
import { eventBus } from "@/main";
import moment from "moment";

export default {
  name: "",
  components: {},
  props: {
    user: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data: () => {
    return {
      selected_filter: "all",
      view_filter: [
        {
          value: "all",
          name: "All",
        },
        {
          value: "2021",
          name: "2021",
        },
      ],
      test_value: 60,
      search_student_input: "",
      student_data: [],
      selected_school: null,
      show_remainder: false,
      user_to_remaind: null,
      remind_type: "student",
      report_data: {},
      show_selected_student_options: false,
      isLoading: false,
    };
  },
  mounted() {
    let vm = this;
    vm.getAllStudent();
    vm.getReportStatistics();
  },
  computed: {},
  watch: {
    search_student_input(val) {
      let vm = this;
      vm.searchStudent(val);
    },
  },
  methods: {
    remindAll(value) {
      let vm = this;
      vm.remind_type = value;
      vm.show_remainder = true;
    },
    getReportStatistics() {
      let vm = this;
      vm.$store
        .dispatch("INSTRUCTOR_REPORT_SCHOOL_STUDENT_PHASE1")
        .then((responce) => {
          vm.report_data = responce.data;
        })
        .catch((error) => { });
    },
    closeRemainder() {
      let vm = this;
      vm.show_remainder = false;
    },
    approveStudent(item) {
      let vm = this;
      vm.$store
        .dispatch("INSTRUCTOR_APPROVE_SCHOOL_STUDENT", {
          student_id: item.id,
        })
        .then((responce) => {
          eventBus.$emit("openDialogMessage", {
            title: "Consultant Approved",
            message:
              "You have successfully approved <span style='color: #000;font-size: 16px;'>" +
              item.first_name +
              " " +
              item.last_name +
              "</span>’s Profile, You can now start to match them with proposed related interships.",
            action_label: "Get Started",
            action_path:
              "/instructor/invitation-profile-build/intership-selection-distribution",
            action_close_label: "Close",
          });
          vm.getAllStudent();
          vm.$notify({
            group: "status",
            title: "Success",
            text: "Consultant profile is now approved",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            title: "Success",
            text: "Something went wrong, try again",
            type: "warn",
            duration: 3000,
          });
        });
    },
    searchStudent(query) {
      let vm = this;
      if (query) {
        vm.isLoading = true;
        vm.$store
          .dispatch("INSTRUCTOR_SEARCH_SCHOOL_STUDENT", {
            class_id: vm.selected_school ? vm.selected_school.id : 0,
            query: query,
          })
          .then((responce) => {
            vm.isLoading = false;
            vm.student_data = responce.data.map((item) => {
              eventBus.$set(item, "checked", false);
              return item;
            });
          })
          .catch((error) => {
            vm.isLoading = false;
          });
      } else {
        vm.getAllStudent();
      }
    },
    filterSchoolStudent(query) {
      let vm = this;
      vm.isLoading = true;
      vm.$store
        .dispatch("INSTRUCTOR_FILTER_SCHOOL_STUDENT", {
          class_id: vm.selected_school ? vm.selected_school.id : 0,
          filter_by: query,
        })
        .then((responce) => {
          vm.isLoading = false;
          vm.student_data = responce.data.map((item) => {
            eventBus.$set(item, "checked", false);
            return item;
          });
        })
        .catch((error) => {
          vm.isLoading = false;
        });
    },
    getSelectedSchool(item) {
      let vm = this;
      vm.selected_school = item;
      vm.isLoading = true;
      vm.$store
        .dispatch("GET_ALL_SCHOOL_STUDENT", {
          id: item.data.id,
          action: item.type,
        })
        .then((responce) => {
          vm.isLoading = false;
          vm.student_data = responce.data.map((item) => {
            eventBus.$set(item, "checked", false);
            return item;
          });
        })
        .catch((error) => {
          vm.isLoading = false;
        });
    },
    sendInvitation(item) {
      let vm = this;
      vm.$store
        .dispatch("INVITE_SCHOOL_STUDENT", { copy_id: item.copy })
        .then((responce) => {
          eventBus.$emit("openDialogMessage", {
            title: "Invitation successfully sent",
            message:
              "A notification has been sent to <span style='color: #000;font-size: 16px;'>" +
              item.first_name +
              " " +
              item.last_name +
              "</span>, we will notify you once he starts building his profile to be approved later.",
            action_label: "",
            action_path: "",
            action_close_label: "Close",
          });
          vm.getAllStudent();
          vm.$notify({
            group: "status",
            type: "success",
            title: "Mesage",
            text: "Invite sent",
          });
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            type: "warn",
            title: "Warning",
            text: "Invitation not sent",
          });
        });
    },
    getAllStudent() {
      let vm = this;
      vm.isLoading = true;
      vm.$store
        .dispatch("GET_ALL_SCHOOL_STUDENT", { id: 0, action: "all" })
        .then((responce) => {
          vm.isLoading = false;
          vm.student_data = responce.data.map((item) => {
            eventBus.$set(item, "checked", false);
            return item;
          });
        })
        .catch((error) => {
          vm.isLoading = false;
        });
    },
    inviteSelectedStudent() {
      let vm = this;
      let payload = { ids: vm.validateCheckedStudent("ids") };
      vm.$store
        .dispatch("INSTRUCTOR_SCHOOL_STUDENT_INVITE_SELECTED_PHASE1", payload)
        .then((responce) => {
          eventBus.$emit("openDialogMessage", {
            title: "Invitation successfully sent",
            message:
              "A notification has been sent to all selected consultant, we will notify you once they starts building there profile to be approved later.",
            action_label: "",
            action_path: "",
            action_close_label: "Close",
          });
          vm.getAllStudent();
          vm.$notify({
            group: "status",
            type: "success",
            title: "Mesage",
            text: "Invitation sent",
          });
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            type: "warn",
            title: "Warning",
            text: "Invitation not sent",
          });
        });
    },
    approveSelectedStudent() {
      let vm = this;
      let payload = { ids: vm.validateCheckedStudent("ids") };
      vm.$store
        .dispatch("INSTRUCTOR_SCHOOL_STUDENT_APPROVE_SELECTED_PHASE1", payload)
        .then((responce) => {
          eventBus.$emit("openDialogMessage", {
            title: "Consultant Approved",
            message:
              "You have successfully approved selected profile, You can now start to match them with proposed related interships.",
            action_label: "Get Started",
            action_path:
              "/instructor/invitation-profile-build/intership-selection-distribution",
            action_close_label: "Close",
          });
          vm.getAllStudent();
          vm.$notify({
            group: "status",
            type: "success",
            title: "Mesage",
            text: "Selected consultant have been approved",
          });
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            type: "warn",
            title: "Warning",
            text: "Something went wrong, Try again",
          });
        });
    },
    remindSelectedStudent() {
      let vm = this;
      vm.user_to_remaind = vm.validateCheckedStudent("ids");
      vm.remind_type = "checked";
      vm.show_remainder = true;
    },
    deleteSelectedStudent() {
      let vm = this;
      let payload = { ids: vm.validateCheckedStudent("ids") };
      vm.$store
        .dispatch("INSTRUCTOR_SCHOOL_STUDENT_DELETE_SELECTED_PHASE1", payload)
        .then((responce) => {
          vm.getAllStudent();
          vm.$notify({
            group: "status",
            type: "success",
            title: "Mesage",
            text: "Selected consultant have been deleted",
          });
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            type: "warn",
            title: "Warning",
            text: "Something went wrong, Try again",
          });
        });
    },
    exportSelectedStudent() {
      let vm = this;
      let payload = { ids: vm.validateCheckedStudent("ids") };
      vm.$store
        .dispatch("INSTRUCTOR_SCHOOL_STUDENT_EXPORT_SELECTED_PHASE1", payload)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", Date.now() + "_student.xlsx");
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            type: "warn",
            title: "Warning",
            text: "Something went wrong, Try again",
          });
        });
    },
    validateCheckedStudent(type = "validate") {
      let vm = this;
      if (type == "validate") {
        vm.show_selected_student_options =
          vm.student_data
            .map((item) => item.checked)
            .filter((item) => item == true).length > 0;
        return;
      }
      return vm.student_data
        .filter((item) => item.checked == true)
        .map((item) => item.id);
    },
    checkStudent() {
      let vm = this;
      vm.validateCheckedStudent();
    },
    checkAllStudent({ target }) {
      let vm = this;
      if (target.checked) {
        vm.student_data = vm.student_data.map((item) => {
          eventBus.$set(item, "checked", true);
          return item;
        });
      } else {
        vm.student_data = vm.student_data.map((item) => {
          eventBus.$set(item, "checked", false);
          return item;
        });
      }
      vm.validateCheckedStudent();
    },
    selectPath(item) {
      let vm = this;
      vm.$router.push({
        name: "instructor",
        params: { main_menu: item.main_name, sub_menu: item.name },
      });
    },
    deleteStudent(item) {
      let vm = this;
      vm.$store
        .dispatch("INSTRUCTOR_DELETE_SCHOOL_STUDENT", {
          student_id: item.id,
        })
        .then((responce) => {
          vm.getAllStudent();
          vm.$notify({
            group: "status",
            title: "Success",
            text: "Consultant is now deleted",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            title: "Success",
            text: "Something went wrong, try again",
            type: "warn",
            duration: 3000,
          });
        });
    },
    sendRemainder(item) {
      let vm = this;
      vm.user_to_remaind = item;
      vm.remind_type = "student";
      vm.show_remainder = true;
    },
    sendMessage(item) {
      window.parent.postMessage({ message: "sendMessage", value: item }, "*");
    },
    viewProfile(item) {
      let item_id = window.btoa(item.id);
      let name =
        item.first_name.toLowerCase().replace(/\s/g, "-") +
        "-" +
        item.last_name.toLowerCase().replace(/\s/g, "-") +
        "-" +
        item_id;
      window.parent.postMessage(
        {
          message: "routeNow",
          value: {
            name: "consultant-public-profile",
            params: { name: name },
          },
        },
        "*"
      );
    },
  },
};
</script>
<style lang="scss" scoped>
$assets: "~@/assets";

.instruct-wrapper {
  width: 100%;
  height: calc(100% - 0px);
  display: flex;
  flex-direction: column;
  background: #ddd;
  padding: 15px;

  .instruct-widget {
    height: 100%;
    position: relative;

    .custom-resizer {
      height: 100%;
    }

    .instruct-list {
      display: flex;
      flex-direction: column;
      height: 100%;
      min-width: calc(100% - 500px);
      width: 100%;
      border-radius: 5px;

      .instruct-header {
        height: 130px;
        background: #fff;
        border-top-right-radius: 5px;
        border-top-left-radius: 5px;

        .search-add-btn-widget {
          padding: 15px 10px;
          padding-bottom: 0px;
          display: grid;
          grid-column-gap: 20px;
          border-top-right-radius: 5px;
          border-top-left-radius: 5px;

          .search-widget {
            border: 3px solid #d8d8d8;
            height: 45px;
            display: flex;
            align-items: center;
            padding: 0px 10px;
            border-radius: 5px;

            img {
              width: 25px;
              height: 25px;
            }

            input {
              height: 30px;
              width: 100%;
              padding-left: 15px;
              outline: none;
              border: none;
            }
          }

          .add-btn {
            width: 191px;
            height: 45px;
            background: #1885ad 0% 0% no-repeat padding-box;
            border-radius: 5px;
            opacity: 1;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;

            img {
              margin-left: 10px;
            }
          }
        }

        .school-widget {
          padding: 0px 10px;
          padding-top: 16px;
          display: flex;
          justify-content: space-between;
          align-items: center;

          h2 {
            margin: 0px;
            font-size: 18px;
          }

          .table-options {
            display: flex;
            align-items: center;
          }
        }

        .filter-widget {
          display: flex;
          padding: 0px 10px;
          justify-content: space-between;

          .filter-select-widget {
            display: flex;
            align-items: center;

            .filter-title {
              color: rgb(156, 156, 156);
            }

            .filter-select-widget {
              display: flex;
              align-items: center;
              cursor: pointer;

              .filter-selected-label {
                span {
                  color: #0884af;
                }
              }
            }
          }

          .filter-widget-options {
            display: flex;
            align-items: center;

            .btn-invite {
              width: 130px;
              height: 33px;
              background: #0884af;
              border-radius: 5px;
              color: #fff;
              margin-right: 10px;
            }

            .btn-approve {
              width: 110px;
              height: 33px;
              background: #1ba5a4;
              border-radius: 5px;
              color: #fff;
            }

            .table-menu {
              margin-left: 32px;
            }
          }
        }
      }

      .instruct-body {
        background: #fff;
        padding: 10px 10px;
        height: calc(100% - 130px);
        overflow-y: auto;
        padding-top: 0px;
        padding-bottom: 60px;
        border-bottom-right-radius: 5px;
        border-bottom-left-radius: 5px;

        .table-data {
          border-collapse: collapse;
          border-spacing: 0;
          width: 100%;

          tr {
            &.row-data {
              background: #fff;
            }

            &:hover {
              background: rgb(248, 248, 248);
              cursor: pointer;
            }

            th {
              border-bottom: none;
              padding: 10px 3px !important;
              text-align: left;
              color: #334d6eb0;
              font-size: 12px;

              &.stick-title {
                position: sticky;
                top: 0px;
                background: #fff;
                z-index: 999;
              }

              &.center {
                display: flex;
                align-content: center;

                input {
                  position: relative;
                  top: 0px;
                  margin-right: 5px;
                  margin: 0px 20px;
                }
              }

              .force-start {
                display: flex;
                align-items: center;

                input {
                  position: relative;
                  top: -1px;
                  left: -7px;
                  margin-right: 5px;
                }
              }

              &.text-center {
                text-align: center;
              }
            }

            td {
              text-align: left;
              border-bottom: none;
              padding: 8px 3px;
              font-size: 13px;
              color: rgb(28, 28, 28);
              border-bottom: 1px solid #ebeff2;

              .checkbox {
                position: relative;
                top: -1px;
                left: -7px;
                margin-right: 5px;
              }

              .profile-content {
                display: flex;
                align-items: center;

                .student-profile {
                  height: 35px !important;
                  width: 35px !important;
                  background: #1ba5a4;
                  border-radius: 50%;
                  margin-right: 10px;
                }

                .profile-alphabet {
                  margin-right: 10px;
                  height: 35px !important;
                  width: 35px !important;
                  background: #1ba5a4;
                  border-radius: 50%;
                  display: flex;
                  align-items: center;
                  justify-content: center;

                  span {
                    font-size: 13px;
                    color: #fff;
                  }
                }
              }

              &.email {
                color: #334d6eb0;
                font-size: 13px;
              }

              .invitation-status {
                padding: 8px 10px;
                width: 130px;
                border-radius: 5px;
                text-align: center;

                &.received {
                  border: 1px solid #1ba5a4;
                  color: #1ba5a4;
                }

                &.sent {
                  border: 1px solid #0884af;
                  color: #0884af;
                }
              }

              .approve-status {
                padding: 8px 10px;
                width: 110px;
                border-radius: 5px;
                text-align: center;

                span {
                  margin-right: 5px;
                }

                &.approved {
                  border: 1px solid #1ba5a4;
                  color: #1ba5a4;
                }
              }

              .progress-widget {
                width: 80px;
              }

              .table-menu {
                position: relative;
              }

              .center {
                display: flex;
                justify-content: center;
              }

              &:first-child {
                border-top-left-radius: 5px;
                border-bottom-left-radius: 5px;
              }

              &:last-child {
                border-top-right-radius: 5px;
                border-bottom-right-radius: 5px;
              }

              &.text-center {
                text-align: center;
              }

              .btn-invite {
                width: 130px;
                height: 33px;
                background: #0884af;
                border-radius: 5px;
                color: #fff;
              }

              .btn-approve {
                width: 110px;
                height: 33px;
                background: #1ba5a4;
                border-radius: 5px;
                color: #fff;
              }
            }
          }
        }
      }
    }

    .instruct-details {
      width: 260px;
      min-width: 400px;
      max-width: 500px;
      display: flex;
      flex-direction: column;
      height: 100%;
      background: #fff;
      border-radius: 5px;

      .instruct-header {
        padding: 20px;
        height: 350px;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
        align-items: center;

        .student-profile {
          height: 100px;
          width: 100px;
          border-radius: 50%;
        }

        .student-name {
          font-size: 20px;
          margin: 3px 0px;
        }

        .student-job {
          margin: 3px 0px;
          font-size: 17px;
          color: #0884af;
        }

        .student-content {
          font-size: 15px;
          text-align: center;
        }

        .student-email {
          margin: 3px 0px;
          color: #0884af;
        }

        .student-phone {
          margin: 3px 0px;
          color: #0884af;
        }
      }

      .instruct-body {
        height: calc(100% - 350px);
        padding-bottom: 60px;
        display: flex;
        flex-direction: column;
        padding: 10px;

        .student-post-widget {
          height: 100%;
          width: 100%;
          padding: 10px;
          border-radius: 5px;
          background: #e4e4e4;

          .header-widget {
            height: 40px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .title {
              font-weight: 500;
            }

            .btn-view-in-feed {
              color: #0884af;
              font-size: 14px;
            }
          }

          .body-widget {
            height: calc(100% - 40px);
            overflow-y: auto;
            padding-bottom: 20px;

            .post-widget-item {
              background: #fff;
              border-radius: 5px;
              padding: 8px;
              margin-bottom: 15px;

              .post-header {
                display: flex;
                align-items: center;

                .post-profile {
                  width: 40px;
                  height: 40px;
                  border-radius: 50%;
                  margin-right: 10px;
                }

                .post-ower {
                  width: calc(100% - 30px);

                  .name {
                    margin-bottom: 1px;
                    margin-top: 0px;
                    font-size: 16px;
                    color: #000;
                  }

                  .time {
                    color: #828282;
                    font-size: 14px;
                  }
                }
              }

              .post-body {
                .post-content {
                  font-size: 15px;
                }

                .post-image {
                  width: 100%;
                  height: 100px;
                  border-radius: 5px;
                }
              }
            }
          }
        }
      }

      .empty-widget {
        display: flex;
        align-content: center;
        justify-content: center;

        h1 {
          font-size: 20px;
          color: #ddd;
          margin-top: 200px;
        }
      }
    }
  }

  .form-widget-modal {
    width: 500px;
    min-height: 200px;
    padding: 20px;
  }

  .student-not-found-widget {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    background: #fff;
    border-radius: 5px;
  }
}

.search-contact-item {
  padding: 10px 15px;
  display: flex;
  cursor: pointer;
  align-items: center;

  img {
    border-radius: 50%;
    margin-right: 8px;
  }

  &:hover {
    background: rgb(250, 250, 250);
  }
}

.selected-search-contact-item {
  padding: 5px 12px;
  display: flex;
  align-items: center;
  cursor: pointer;
  border: 1px solid #ddd;
  margin-top: 10px;
  border-radius: 15px;
  font-size: 11px;

  img {
    border-radius: 50%;
    margin-right: 8px;
  }

  &:hover {
    background: rgb(250, 250, 250);
  }
}
</style>
